"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2781],{

/***/ 40803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ EBottomBarActiveItem; }
/* harmony export */ });
var EBottomBarActiveItem;
(function(EBottomBarActiveItem) {
    EBottomBarActiveItem["cart"] = "quickCart";
    EBottomBarActiveItem["favourite"] = "favorites";
    EBottomBarActiveItem["nearestProducts"] = "itemNearMe";
    EBottomBarActiveItem["reels"] = "reel";
})(EBottomBarActiveItem || (EBottomBarActiveItem = {}));


/***/ }),

/***/ 7710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98592);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18533);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12781);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 27px;\n  color: #ea475c;\n  position: absolute;\n  margin-top: 41px;\n  margin-left: 40px;\n  margin-right: 40px;\n  cursor: pointer;\n  z-index: 1;\n  direction: initial;\n\n  @media screen and (max-width: 760px) {\n    display: inline-block;\n    float: initial;\n    width: 100%;\n    margin: 0;\n    padding: 15px 22px 0 22px;\n    position: relative;\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "BackButton__MainWrap",
    componentId: "sc-a9e543e-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "text-align:right;" : "");
});
var BackButton = function(props) {
    var backFunction = props.backFunction, location = props.location;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .translationDataState */ .Jv), _back = ref.back, back = _back === void 0 ? "back" : _back;
    var rtl = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .tourConfigsState */ .Uq).rtl;
    var history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_4__/* .useHistory */ .k6)();
    var pushBack = function() {
        if (backFunction) {
            backFunction();
        } else {
            var paths = location.pathname.split("/");
            if (paths[paths.length - 1] === "") paths.pop();
            paths.pop();
            history.push(paths.join("/"));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        onClick: pushBack,
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                className: "fas fa-chevron-left"
            }),
            " ",
            back
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_router_dom__WEBPACK_IMPORTED_MODULE_4__/* .withRouter */ .EN)(BackButton));


/***/ }),

/***/ 73491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_BaseLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 1 modules
var react_router_dom = __webpack_require__(16592);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
;// CONCATENATED MODULE: ./components/ticketingNew/components/TourLanguageSelect.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n  padding: 0 5px;\n  line-height: 1.1;\n  font-size: 15px;\n\n  @media screen and (max-width: 760px) {\n    width: 33.33%;\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  color: white;\n  text-transform: uppercase;\n  position: relative;\n  margin: 0 5px;\n\n  div.mainItem {\n    cursor: pointer;\n  }\n\n  div.optionItem {\n    line-height: 1.3;\n    background: transparent;\n    cursor: pointer;\n\n    display: flex;\n    color: white;\n    align-items: center;\n    justify-content: start;\n    margin-bottom: 10px;\n\n    i {\n      font-size: 5px;\n      margin: 5px;\n      text-decoration: initial !important;\n    }\n\n    span {\n      display: block !important;\n    }\n\n    &.active {\n      text-decoration: underline;\n    }\n  }\n\n  div.optionsWrap {\n    position: absolute;\n    //padding: 16px 0 11px 27px;\n    background-color: rgba(44, 44, 44, 0.9);\n    border-radius: 12px;\n    //margin-left: -40px;\n    width: calc(100% + 51px);\n\n    //padding: 20px 3px 10px 10px;\n    padding: 10px 3px 5px 10px;\n    ",
        ";\n\n    left: 0;\n    margin-left: 0;\n    margin-top: 21px;\n  }\n\n  @media screen and (max-width: 760px) {\n    div.optionsWrap {\n      margin-top: 9px;\n      width: 100vw;\n      position: absolute;\n      left: -20px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var CustomSelectWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TourLanguageSelect__CustomSelectWrap",
    componentId: "sc-81eec9ae-0"
})(_templateObject());
var CustomSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TourLanguageSelect__CustomSelect",
    componentId: "sc-81eec9ae-1"
})(_templateObject1(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "padding: 10px 10px 5px 3px;right: 0;left: initial;right: -20px;" : "");
});
var TourLanguageSelect = function(props) {
    var tourId = props.tourId;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _current_tour_has_no_language = ref.current_tour_has_no_language, current_tour_has_no_language = _current_tour_has_no_language === void 0 ? "Current tour has no language" : _current_tour_has_no_language, _no_language = ref.no_language, no_language = _no_language === void 0 ? "no language" : _no_language;
    var ref1 = (0,react.useState)(null), duplicates = ref1[0], setDuplicates = ref1[1];
    var ref2 = (0,react.useState)(false), duplicatesIsOpen = ref2[0], setDuplicatesIsOpen = ref2[1];
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var initialDuplicatesRes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TreedisPublicDAO/* default.getDuplicates */.Z.getDuplicates(tourId)
                        ];
                    case 1:
                        initialDuplicatesRes = _state.sent();
                        if (initialDuplicatesRes && initialDuplicatesRes.message.includes("Success")) {
                            setDuplicates(initialDuplicatesRes.duplicates);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    var getCurrentLanguage = function() {
        var pathnameSplitted = window.location.pathname.split("/");
        return (duplicates || []).find(function(duplicate) {
            return pathnameSplitted.includes(duplicate.slug);
        });
    };
    var isLanguageActive = function(slug) {
        var pathnameSplitted = window.location.pathname.split("/");
        return pathnameSplitted.find(function(p) {
            return p === slug;
        });
    };
    var handleLanguageClick = function(slug) {
        return function() {
            if (!isLanguageActive(slug)) {
                replaceSlug(slug);
                setDuplicatesIsOpen(false);
            }
        };
    };
    var replaceSlug = function(slug) {
        var pathnames = window.location.pathname.split("/");
        pathnames.shift();
        var targetLink = "/".concat(pathnames[0], "/").concat(pathnames[0] === "experience" ? pathnames[1] : slug).concat(pathnames[0] === "experience" ? "/".concat(slug) : "");
        location.replace(window.location.origin + targetLink);
    };
    var currentLanguageObj = getCurrentLanguage();
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    return duplicates && duplicates.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomSelectWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "far fa-globe"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomSelect, {
                rtl: rtl,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mainItem",
                        onClick: function() {
                            return setDuplicatesIsOpen(!duplicatesIsOpen);
                        },
                        children: (currentLanguageObj === null || currentLanguageObj === void 0 ? void 0 : currentLanguageObj.language) || (currentLanguageObj === null || currentLanguageObj === void 0 ? void 0 : currentLanguageObj.languageEn) || current_tour_has_no_language
                    }),
                    duplicatesIsOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "optionsWrap",
                        children: duplicates.map(function(duplicate, num) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("optionItem", isLanguageActive(duplicate.slug) && "active"),
                                onClick: handleLanguageClick(duplicate.slug),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-circle"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (duplicate === null || duplicate === void 0 ? void 0 : duplicate.language) || (duplicate === null || duplicate === void 0 ? void 0 : duplicate.languageEn) || "".concat(no_language, " / ").concat(duplicate.slug)
                                    })
                                ]
                            }, num);
                        })
                    })
                ]
            }),
            duplicatesIsOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "fas fa-chevron-up"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "fas fa-chevron-down"
            })
        ]
    }) : null;
};
/* harmony default export */ var components_TourLanguageSelect = (TourLanguageSelect);

;// CONCATENATED MODULE: ./components/ticketingNew/components/BaseLayout.tsx




function BaseLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n  margin: auto;\n  background-color: ",
        ";\n  //background: conic-gradient(from 193.61deg at 46.18% 51.15%, #000000 -139.17deg, #eeeeee 10.44deg, #ffffff 157.82deg, #000000 220.83deg, #eeeeee 370.44deg);\n  ",
        ";\n\n  header {\n    height: 58px;\n    width: 100%;\n    background-color: #282828;\n    color: white;\n    display: flex;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n    z-index: 1;\n\n    .bl-header-clientPic {\n      //left: 15px;\n      //position: absolute;\n      //background: #ccadad;\n      width: 100px;\n      height: 100%;\n      margin-right: 15px;\n\n      &.forMobile {\n        display: none;\n      }\n      object-fit: contain;\n\n      @media screen and (max-width: 760px) {\n        display: none;\n        &.forMobile {\n          display: block;\n          order: 2;\n          width: 33.33%;\n          margin: 0;\n        }\n      }\n    }\n\n    .bl-header-block {\n      font-size: 16px;\n      position: absolute;\n      display: flex;\n      align-items: center;\n      margin: auto;\n      justify-content: center;\n      height: 100%;\n      width: auto;\n      left: ",
        ";\n      right: ",
        ";\n\n      @media screen and (max-width: 760px) {\n        width: 100%;\n        right: 0;\n        //right: auto;\n        span {\n          display: none;\n        }\n      }\n\n      & > * {\n        line-height: 1;\n      }\n\n      .bl-header-lang {\n        display: flex;\n        align-items: center;\n\n        i {\n          font-size: 16px;\n        }\n\n        select {\n          line-height: 1;\n          background: transparent;\n          color: white;\n          font-size: 16px;\n          padding: 0;\n          min-width: 43px;\n        }\n\n        @media screen and (max-width: 760px) {\n          order: 1;\n          width: 33.33%;\n          padding-left: 15px;\n        }\n      }\n\n      .loginButton-wrap {\n        .signButton {\n          border: 1.5px solid #ffffff;\n          box-sizing: border-box;\n          filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n          border-radius: 6px;\n          width: 83px;\n          height: 31px;\n          background: transparent;\n          color: white;\n          margin: 0 15px;\n        }\n\n        @media screen and (max-width: 760px) {\n          order: 3;\n          margin: 0;\n          text-align: right;\n          width: 33.33%;\n          padding-right: 15px;\n          button {\n            margin: 0 !important;\n          }\n        }\n      }\n\n      .buyNowLink {\n        margin: 0 15px;\n        text-decoration: underline;\n\n        &:hover,\n        &:active {\n          color: white;\n        }\n\n        @media screen and (max-width: 760px) {\n          order: 3;\n          width: 33.33%;\n          text-align: right;\n          margin: 0;\n          padding-right: 15px;\n        }\n      }\n    }\n  }\n\n  .bl-inner-content {\n    min-height: calc(100vh - 155px);\n    overflow: hidden;\n  }\n\n  footer {\n    height: 97px;\n    width: 100%;\n    background-color: #282828;\n    color: white;\n    margin-top: 35px;\n\n    .bl-footer-copyright {\n      height: 45px;\n      margin: 30px;\n      position: absolute;\n      display: flex;\n      align-items: center;\n      font-size: 22px;\n\n      span {\n        margin: 0 15px 0 5px;\n      }\n\n      img {\n        margin-top: 3px;\n        margin-left: 5px;\n        width: 101px;\n        object-fit: contain;\n        height: 46px;\n\n        &[alt='treedis'] {\n          filter: brightness(0) saturate(100%) invert(45%) sepia(15%) saturate(3730%) hue-rotate(311deg) brightness(90%) contrast(105%);\n        }\n      }\n    }\n  }\n"
    ]);
    BaseLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var BaseLayoutStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BaseLayout__BaseLayoutStyled",
    componentId: "sc-bdc48fe6-0"
})(BaseLayout_templateObject(), function(p) {
    return p.transparentBg ? "#E5E5E528" : "#e5e5e5";
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "direction: rtl; text-align: right;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "50px" : "initial");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "initial" : "50px");
});
var ClientPic = function(param) {
    var _forMobile = param.forMobile, forMobile = _forMobile === void 0 ? false : _forMobile, _src = param.src, src = _src === void 0 ? "" : _src;
    return src ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: src,
        alt: "client_logo",
        className: classnames_default()("bl-header-clientPic", forMobile && "forMobile")
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("bl-header-clientPic", forMobile && "forMobile")
    });
};
var BaseLayout = function(props) {
    var ref, ref1;
    var location = props.location, children = props.children, _tourId = props.tourId, tourId = _tourId === void 0 ? 0 : _tourId, _whiteLabelData = props.whiteLabelData, whiteLabelData = _whiteLabelData === void 0 ? {} : _whiteLabelData, _transparentBg = props.transparentBg, transparentBg = _transparentBg === void 0 ? false : _transparentBg;
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    var ref2 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _log_in = ref2.log_in, log_in = _log_in === void 0 ? "log in" : _log_in, _buy_now = ref2.buy_now, buy_now = _buy_now === void 0 ? "Buy now" : _buy_now, _poweredBy = ref2.poweredBy, poweredBy = _poweredBy === void 0 ? "Powered by" : _poweredBy, _already_have_a_ticket = ref2.already_have_a_ticket, already_have_a_ticket = _already_have_a_ticket === void 0 ? "Already have a ticket?" : _already_have_a_ticket, _dont_have_a_tour_ticket = ref2.dont_have_a_tour_ticket, dont_have_a_tour_ticket = _dont_have_a_tour_ticket === void 0 ? "Don't have a tour ticket?" : _dont_have_a_tour_ticket;
    var isLoginPage = location.pathname.includes("login");
    var pathnames = location.pathname.split("/");
    pathnames.shift();
    var homeLink = "/".concat(pathnames[0], "/").concat(pathnames[1]).concat(pathnames[0] === "experience" ? "/".concat(pathnames[2]) : "", "/book");
    var loginLink = "/".concat(pathnames[0], "/").concat(pathnames[1]).concat(pathnames[0] === "experience" ? "/".concat(pathnames[2]) : "", "/login");
    var clietnLogoSrc = whiteLabelData.logo && (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : (ref = whiteLabelData.logo) === null || ref === void 0 ? void 0 : ref.includes("clients")) ? whiteLabelData.logo : "";
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref3[0], setInfoModalData = ref3[1];
    var closeInfoModal = function() {
        return setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: false
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayoutStyled, {
        transparentBg: transparentBg,
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientPic, {
                        src: clietnLogoSrc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-header-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientPic, {
                                forMobile: true,
                                src: clietnLogoSrc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: !isLoginPage ? already_have_a_ticket : dont_have_a_tour_ticket
                            }),
                            isLoginPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: homeLink,
                                className: "buyNowLink",
                                onClick: closeInfoModal,
                                children: buy_now
                            }),
                            !isLoginPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: loginLink,
                                className: "loginButton-wrap",
                                onClick: closeInfoModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "signButton",
                                    children: log_in
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TourLanguageSelect, {
                                tourId: tourId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-inner-content",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bl-footer-copyright",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "far fa-copyright"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: poweredBy
                        }),
                        whiteLabelData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : (ref1 = whiteLabelData.domainUrl) === null || ref1 === void 0 ? void 0 : ref1.includes("http")) ? whiteLabelData.domainUrl : "http://" + whiteLabelData.domainUrl,
                            rel: "noreferrer",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: whiteLabelData.logo,
                                alt: "whitelabel logo"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://treedis.com/",
                            rel: "noreferrer",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "treedis",
                                src: "/logo.png",
                                alt: "treedis logo"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_BaseLayout = ((0,react_router/* withRouter */.EN)(BaseLayout));


/***/ }),

/***/ 47887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ EInfoModal; },
  "Z": function() { return /* binding */ components_InfoModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./components/ticketingNew/components/BaseLayout.tsx + 1 modules
var BaseLayout = __webpack_require__(73491);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 1 modules
var react_router_dom = __webpack_require__(16592);
// EXTERNAL MODULE: ./components/ticketingNew/components/TicketItemMobile.tsx
var TicketItemMobile = __webpack_require__(47238);
// EXTERNAL MODULE: ./components/ticketingNew/components/OrderDetailsBlock/index.tsx + 2 modules
var OrderDetailsBlock = __webpack_require__(61749);
// EXTERNAL MODULE: ./components/ticketingNew/pages/Order/index.tsx + 2 modules
var Order = __webpack_require__(67020);
// EXTERNAL MODULE: ./components/ticketingNew/pages/OrderSuccess.tsx + 1 modules
var OrderSuccess = __webpack_require__(99931);
;// CONCATENATED MODULE: ./components/ticketingNew/components/OrderTicketFromTour/index.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 20px;\n  width: 1162px;\n  max-width: 100%;\n  margin: 44px auto 43px auto;\n  background: rgba(79, 79, 79, 0.6);\n  backdrop-filter: blur(150px);\n  padding: 54px 180px;\n  color: white;\n  position: relative;\n  text-align: center;\n\n  .otft-home {\n    font-weight: 600;\n    font-size: 18px;\n    color: white;\n    text-decoration: none;\n    position: absolute;\n    left: 65px;\n    top: 69px;\n\n    i {\n      margin-right: 5px;\n    }\n  }\n\n  .otft-header {\n    font-weight: 400;\n    font-size: 60px;\n    line-height: 90px;\n    margin-bottom: 10px;\n  }\n\n  .otft-title {\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 33px;\n    margin-bottom: 10px;\n  }\n\n  .otft-message {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 30px;\n    margin-bottom: 40px;\n  }\n\n  .otft-content {\n    display: flex;\n  }\n\n  .otft-tickets {\n    color: black;\n    width: 50%;\n\n    max-height: 435px;\n    overflow-y: scroll;\n    padding-right: 5px;\n  }\n  .otft-payment {\n    text-align: initial;\n    width: 50%;\n\n    .bl-ticket-order {\n      width: 100%;\n      padding: 28px;\n      color: black;\n      margin-left: 15px;\n    }\n\n    .bl-ticket-order-pay-btn {\n      padding: 8px 15px;\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderTicketFromTour__MainWrap",
    componentId: "sc-3101faca-0"
})(_templateObject());
var OrderTicketFromTour = function(props) {
    var location = props.location, _message = props.message, message = _message === void 0 ? "Your ticket time is expired.. but you can buy a new ticket" : _message, match = props.match;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref[0], setInfoModalData = ref[1];
    console.log("infoModalData", infoModalData);
    var ref1 = infoModalData === null || infoModalData === void 0 ? void 0 : infoModalData.ticketLoginData, ticketing = ref1.ticketing, ticketingOrderedTicket = ref1.ticketingOrderedTicket, ticketingTourTicket = ref1.ticketingTourTicket, tour = ref1.tour;
    var participants = [
        {
            id: Date.now(),
            fullName: ticketingOrderedTicket.name,
            email: ticketingOrderedTicket.email,
            isGift: ticketingOrderedTicket.isGift
        }, 
    ];
    var ref2 = (0,react.useState)(null), pickedTicketId = ref2[0], setPickedTicketId = ref2[1];
    var ref3 = (0,react.useState)(""), orderLink = ref3[0], setOrderLink = ref3[1];
    var ref4 = (0,react.useState)(Order/* OrderStageEnum.order */.t9.order), orderStage = ref4[0], setOrderStage = ref4[1];
    var homePage = location.pathname.replace(/book.+|book/g, "");
    var closeInfoModal = function() {
        return setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: false
        }));
    };
    var getTicketList = function() {
        //get current orderedTicket data & return tickets of same type (guided, ys, experience)
        //for restriction, return tours that have access to restricted sweep
        if (ticketingOrderedTicket.ticketType === "gameTour") return ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGameTour;
        else if (ticketingOrderedTicket.ticketType === "tourByYourself") return ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingToursByYourself;
        else if (ticketingOrderedTicket.ticketType === "guidedTour") return ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGuidedTour;
        return [];
    };
    //@ts-ignore
    var handlePaymentSuccess = function() {
    //close modal
    //go to login page with inserted ticket id
    };
    var tickets = getTicketList();
    console.log("tickets", tickets);
    console.log("infoModalData", infoModalData);
    if (!tickets || !infoModalData) {
        setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            mode: EInfoModal.error,
            message: infoModalData.mode === EInfoModal.timeIsUp ? "Ticket time is up" : "Area is restricted for this tour"
        }));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "closing..."
        });
    }
    console.log("ticketingOrderedTicket", ticketingOrderedTicket);
    console.log("ticketingTourTicket", ticketingTourTicket);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
        children: [
            orderStage === Order/* OrderStageEnum.order */.t9.order && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_router_dom/* Link */.rU, {
                        to: homePage,
                        className: "otft-home",
                        onClick: closeInfoModal,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-chevron-left"
                            }),
                            "Home Page"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "otft-header",
                        children: "Oops!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "otft-title",
                        children: message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "otft-message",
                        children: "Pick your new ticket"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "otft-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "otft-tickets",
                                children: tickets === null || tickets === void 0 ? void 0 : tickets.map(function(e) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TicketItemMobile/* default */.Z, {
                                        ticket: e,
                                        currencyId: 3,
                                        onPick: function(id) {
                                            return setPickedTicketId(id);
                                        },
                                        pickedId: pickedTicketId
                                    }, e === null || e === void 0 ? void 0 : e.id);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "otft-payment",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailsBlock/* default */.Z, {
                                    tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                                    gameId: tour === null || tour === void 0 ? void 0 : tour.gameId,
                                    matterId: tour === null || tour === void 0 ? void 0 : tour.matterId,
                                    setOrderStage: setOrderStage,
                                    participants: participants,
                                    handlePaymentSuccess: function() {
                                        return setOrderStage(Order/* OrderStageEnum.tourOrderOnlySuccess */.t9.tourOrderOnlySuccess);
                                    },
                                    match: match,
                                    setOrderLink: setOrderLink,
                                    initialTourType: ticketingOrderedTicket === null || ticketingOrderedTicket === void 0 ? void 0 : ticketingOrderedTicket.ticketType,
                                    initialTicketId: pickedTicketId
                                })
                            })
                        ]
                    })
                ]
            }),
            orderStage === Order/* OrderStageEnum.payment */.t9.payment && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "otft-order-frame",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-chevron-left"
                            }),
                            " back"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Payment"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Please enter your payment details"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        src: orderLink
                    })
                ]
            }),
            orderStage === Order/* OrderStageEnum.tourOrderOnlySuccess */.t9.tourOrderOnlySuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSuccess/* default */.Z, {
                minimized: true,
                onLinkClick: closeInfoModal
            })
        ]
    });
};
/* harmony default export */ var components_OrderTicketFromTour = ((0,react_router/* withRouter */.EN)(OrderTicketFromTour));

;// CONCATENATED MODULE: ./components/ticketingNew/components/InfoModal.tsx




function InfoModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  max-width: 100%;\n\n  .im-inner-wrap {\n    background: rgba(79, 79, 79, 0.6);\n    color: white;\n    backdrop-filter: blur(150px);\n    border-radius: 20px;\n    padding: 54px 71px;\n    text-align: center;\n\n    .im-inner-warn {\n      font-weight: 400;\n      font-size: 60px;\n      line-height: 90px;\n      margin-bottom: 10px;\n    }\n\n    .im-inner-title {\n      font-weight: 500;\n      font-size: 22px;\n      line-height: 33px;\n      margin-bottom: 10px;\n    }\n\n    .im-inner-message {\n      font-weight: 400;\n      font-size: 15px;\n      line-height: 22px;\n      margin-bottom: 60px;\n    }\n\n    .im-inner-ok_btn {\n      background-color: #ea475c;\n      border-radius: 12px;\n      color: white;\n      font-weight: 600;\n      font-size: 18px;\n      padding: 15px 34px;\n      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n\n      &:active {\n        opacity: 0.8;\n      }\n\n      i {\n        margin-left: 5px;\n      }\n    }\n  }\n\n  & > .cVideo-modal-videoWrap {\n    width: 100%;\n    height: 100%;\n\n    & > iframe {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .im-redirect-btn {\n    margin-right: 15px;\n  }\n"
    ]);
    InfoModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledModal = (0,styled_components_browser_esm/* default */.ZP)((lib_default())).withConfig({
    displayName: "InfoModal__StyledModal",
    componentId: "sc-d467fa-0"
})(InfoModal_templateObject(), function(props) {
    return props.mode !== EInfoModal.error ? "100%" : "746px";
}, function(props) {
    return props.mode !== EInfoModal.error ? "auto" : "421px";
});
var EInfoModal;
(function(EInfoModal) {
    EInfoModal[EInfoModal["error"] = 0] = "error";
    EInfoModal[EInfoModal["timeIsUp"] = 1] = "timeIsUp";
    EInfoModal[EInfoModal["restrictedArea"] = 2] = "restrictedArea";
})(EInfoModal || (EInfoModal = {}));
var InfoModal = function(props) {
    var root = props.root;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref[0], setInfoModalData = ref[1];
    var ref1 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _oops = ref1.oops, oops = _oops === void 0 ? "Oops!" : _oops, _proceedToPage = ref1.proceedToPage, proceedToPage = _proceedToPage === void 0 ? "Proceed to needed page" : _proceedToPage, _gotIt = ref1.gotIt, gotIt = _gotIt === void 0 ? "Got it" : _gotIt;
    var handleClose = infoModalData.onRequestClose ? infoModalData.onRequestClose : function() {
        return setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: false
        }));
    };
    var handleCloseRedirect = function() {
        window.location.href = infoModalData === null || infoModalData === void 0 ? void 0 : infoModalData.redirectLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModal, {
        isOpen: infoModalData.isOpen,
        onRequestClose: handleClose,
        mode: infoModalData.mode,
        appElement: root,
        children: [
            infoModalData.mode === EInfoModal.error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "im-inner-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "im-inner-warn",
                        children: oops
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "im-inner-title",
                        children: infoModalData.message || "Ticket not found"
                    }),
                    !infoModalData.message && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "im-inner-message",
                        children: "You can find your customer code number on the purchase confirmation Email"
                    }),
                    infoModalData.redirectLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "im-inner-ok_btn",
                        onClick: handleCloseRedirect,
                        children: proceedToPage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "im-inner-ok_btn",
                        onClick: handleClose,
                        children: [
                            gotIt,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-check"
                            })
                        ]
                    })
                ]
            }),
            infoModalData.mode !== EInfoModal.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* default */.Z, {
                transparentBg: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "im-inner-wrap-order",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OrderTicketFromTour, {})
                })
            })
        ]
    });
};
/* harmony default export */ var components_InfoModal = ((0,react_router/* withRouter */.EN)(InfoModal));


/***/ }),

/***/ 72225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12781);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18533);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  //margin-top: 18px;\n\n  @media screen and (max-width: 760px) {\n    margin-top: 9px;\n    max-width: 100%;\n    overflow: hidden;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  margin-top: 5px;\n  text-align: center;\n\n  .bl-card-btn {\n    background: #ffffff;\n    border: 1px solid #000000;\n    box-sizing: border-box;\n    box-shadow: -4px 4px 0px rgba(255, 255, 255, 0.25);\n    border-radius: 12px;\n    padding: 8px 22px;\n\n    &:active {\n      opacity: 0.9;\n    }\n  }\n\n  .bl-btn-hr {\n    width: 65px;\n    top: 0px;\n    border-color: black;\n    position: absolute;\n\n    &.bl-hr-left {\n      left: 20px;\n    }\n\n    &.bl-hr-right {\n      right: 20px;\n    }\n\n    @media screen and (max-width: 760px) {\n      width: 20px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var BlCardBarcode = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MoreInfoBtn__BlCardBarcode",
    componentId: "sc-1aecdbc6-0"
})(_templateObject());
var BlCardBtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MoreInfoBtn__BlCardBtnWrap",
    componentId: "sc-1aecdbc6-1"
})(_templateObject1());
var MoreInfoBtn = function(param) {
    var ticketInfoUlr = param.ticketInfoUlr;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .translationDataState */ .Jv), _more_info = ref.more_info, more_info = _more_info === void 0 ? "More Info" : _more_info;
    return ticketInfoUlr ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlCardBtnWrap, {
        className: "bl-card-btn-wrap",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
            href: ticketInfoUlr.includes("http") ? ticketInfoUlr : "http://".concat(ticketInfoUlr),
            target: "_blank",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    className: "bl-card-btn",
                    children: more_info
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {
                    className: "bl-btn-hr bl-hr-left"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {
                    className: "bl-btn-hr bl-hr-right"
                })
            ]
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlCardBarcode, {
        className: "bl-card-barcode",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
            src: "/ticketing/barcode.png",
            alt: "ticket_barcode"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MoreInfoBtn);


/***/ }),

/***/ 61749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_OrderDetailsBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
;// CONCATENATED MODULE: ./components/ticketingNew/components/DiscountField.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bl-ticket-order-discount {\n    margin-top: 13px;\n    cursor: pointer;\n\n    .bl-ticket-order-discount-text {\n      .fa-ticket-alt {\n        margin-right: 5px;\n      }\n\n      .fa-chevron-down {\n        margin-left: 5px;\n      }\n    }\n\n    .bl-ticket-order-discount-input-activate {\n      display: flex;\n      height: 35px;\n      position: relative;\n\n      .bl-discount-input-wrap {\n        display: flex;\n        position: relative;\n        width: 100%;\n\n        .bl-discount-error-icon {\n          background: #ea475c;\n          width: 14px;\n          height: 14px;\n          position: absolute;\n          right: 10px;\n          border-radius: 50%;\n          color: white;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          top: 10px;\n          font-weight: 300;\n          font-size: 12px;\n          ",
        ";\n        }\n\n        .bl-applied-discount-value {\n          position: absolute;\n          font-weight: 300;\n          font-size: 15px;\n          line-height: 21px;\n          display: flex;\n          align-items: center;\n          top: 8px;\n          height: 18px;\n          right: 12px;\n\n          ",
        ";\n\n          .bl-confirmed-icon-wrap {\n            font-weight: 300;\n            line-height: 21px;\n            width: 14px;\n            height: 14px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background: #59df76;\n            border-radius: 50%;\n            margin-left: 6px;\n            color: white;\n            font-size: 8px;\n          }\n        }\n      }\n\n      i.fa-ticket-alt {\n        z-index: 1;\n        position: absolute;\n        top: 10px;\n        left: 8px;\n        ",
        ";\n      }\n\n      input {\n        padding-left: 25px;\n        height: 35px;\n        background: #ffffff;\n        /* Dark/Dark 1 */\n\n        border: 1px solid #b2bcca;\n        box-sizing: border-box;\n        border-radius: 8px;\n        ",
        ";\n\n        &:active,\n        &:focus {\n          outline: 2px solid #b2bcca;\n        }\n\n        &.error {\n          border-color: #ea475c;\n\n          &:active,\n          &:focus {\n            outline: 2px solid #ea475c;\n          }\n        }\n      }\n\n      button {\n        margin-left: 18px;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        color: #ea475c;\n        background: transparent;\n        border: 2px solid #ea475c;\n        box-sizing: border-box;\n        border-radius: 12px;\n        padding: 0px 35px;\n        ",
        ";\n\n        &:active {\n          background: rgba(234, 71, 92, 0.1);\n        }\n      }\n\n      &.applied {\n        button {\n          color: white;\n          border: none;\n          background-color: #21d349bf;\n\n          &:active {\n            opacity: 0.9;\n          }\n        }\n      }\n    }\n\n    .bl-discount-error-message {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 20px;\n      color: #ea475c;\n      margin-top: 4px;\n      ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var DiscountMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DiscountField__DiscountMainWrap",
    componentId: "sc-8ff49289-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: initial;position: absolute;left: 8px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: initial;left: 15px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin: 0 9px;left: initial;right:8px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "padding: 8px 30px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin-right: 18px;margin-left: 0;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "text-align: right;direction: rtl;" : "");
});
var DiscountField = function(props) {
    var tourId = props.tourId, ticketId = props.ticketId, ticketingType = props.ticketingType, currencySign = props.currencySign, onDiscountApply = props.onDiscountApply;
    var ref = (0,react.useState)(false), isAbleToSetDiscount = ref[0], setIsAbleToSetDiscount = ref[1];
    var ref1 = (0,react.useState)(""), discountCode = ref1[0], setDiscountCode = ref1[1];
    var ref2 = (0,react.useState)(false), discountLoading = ref2[0], setDiscountLoading = ref2[1];
    var ref3 = (0,react.useState)({}), appliedDiscount = ref3[0], setAppliedDiscount = ref3[1];
    var ref4 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _add_a_gift_card_or_discount_code = ref4.add_a_gift_card_or_discount_code, add_a_gift_card_or_discount_code = _add_a_gift_card_or_discount_code === void 0 ? "Add a gift card or discount code" : _add_a_gift_card_or_discount_code, _applyTicket = ref4.applyTicket, applyTicket = _applyTicket === void 0 ? "Apply" : _applyTicket, _confirmed = ref4.confirmed, confirmed = _confirmed === void 0 ? "Confirmed" : _confirmed, _promocode_not_found = ref4.promocode_not_found, promocode_not_found = _promocode_not_found === void 0 ? "promocode not found" : _promocode_not_found;
    var loadPromocode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var promocodeRes, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            4,
                            5
                        ]);
                        if (!(!(appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.amount) && tourId)) return [
                            3,
                            2
                        ];
                        setDiscountLoading(true);
                        return [
                            4,
                            TreedisPublicDAO/* default.getTicketingDiscount */.Z.getTicketingDiscount({
                                query: {
                                    tourId: tourId,
                                    codeName: discountCode,
                                    ticketId: ticketId,
                                    ticketingType: ticketingType
                                }
                            })
                        ];
                    case 1:
                        promocodeRes = _state.sent();
                        if (promocodeRes && promocodeRes.message.includes("Success")) {
                            setAppliedDiscount(promocodeRes.data);
                            onDiscountApply(promocodeRes.data);
                        } else {
                            setAppliedDiscount({
                                error: promocode_not_found
                            });
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        setAppliedDiscount({
                            error: err.message
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setDiscountLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function loadPromocode() {
            return _ref.apply(this, arguments);
        };
    }();
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountMainWrap, {
        className: "bl-ticket-order-discount",
        rtl: rtl,
        children: [
            !isAbleToSetDiscount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-discount-text",
                onClick: function() {
                    return setIsAbleToSetDiscount(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "far fa-ticket-alt"
                    }),
                    " ",
                    add_a_gift_card_or_discount_code,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "far fa-chevron-down"
                    })
                ]
            }),
            isAbleToSetDiscount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("bl-ticket-order-discount-input-activate", appliedDiscount.amount && "applied"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "far fa-ticket-alt"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-discount-input-wrap",
                        children: [
                            appliedDiscount.amount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bl-applied-discount-value",
                                children: [
                                    "-",
                                    appliedDiscount.amount,
                                    appliedDiscount.discountType === "percent" ? "%" : currencySign,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-confirmed-icon-wrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fal fa-check"
                                        })
                                    })
                                ]
                            }),
                            appliedDiscount.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-discount-error-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fal fa-times"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: classnames_default()(appliedDiscount.error && "error"),
                                disabled: discountLoading || appliedDiscount.amount,
                                type: "text",
                                value: discountCode,
                                onChange: function(ev) {
                                    return setDiscountCode(ev.target.value);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: loadPromocode,
                        children: appliedDiscount.amount ? confirmed : applyTicket
                    })
                ]
            }),
            appliedDiscount.error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-discount-error-message",
                children: [
                    "*",
                    appliedDiscount.error
                ]
            })
        ]
    });
};
/* harmony default export */ var components_DiscountField = (DiscountField);

// EXTERNAL MODULE: ./node_modules/react-paypal-button-v2/lib/index.js
var lib = __webpack_require__(86295);
// EXTERNAL MODULE: ./components/ticketingNew/pages/Order/index.tsx + 2 modules
var Order = __webpack_require__(67020);
// EXTERNAL MODULE: ./components/ticketingNew/types.ts
var types = __webpack_require__(84345);
// EXTERNAL MODULE: ./components/util/analytic.ts + 2 modules
var analytic = __webpack_require__(44000);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/ticketingNew/components/InfoModal.tsx + 1 modules
var InfoModal = __webpack_require__(47887);
// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
// EXTERNAL MODULE: ./components/ticketingNew/static.ts
var ticketingNew_static = __webpack_require__(70712);
;// CONCATENATED MODULE: ./components/ticketingNew/components/OrderDetailsBlock/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bl-ticket-order {\n    width: 50%;\n    display: inline-block;\n    background: #ffffff;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.14);\n    padding: 26px 50px 0 53px;\n    height: auto;\n    padding-bottom: 34px;\n    align-self: flex-start;\n\n    .bl-ticket-order-title {\n      font-weight: 500;\n      font-size: 20px;\n      line-height: 30px;\n      margin-bottom: 8px;\n    }\n\n    .bl-ticket-order-subTitle {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 18px;\n      margin-bottom: 10px;\n      color: #828282;\n    }\n\n    .bl-ticket-order-pills {\n      margin-bottom: 15px;\n      display: flex;\n      flex-wrap: wrap;\n\n      .bl-ticket-order-pill {\n        display: flex;\n        align-items: center;\n        border: 0.5px solid #d7d7d7;\n        box-sizing: border-box;\n        box-shadow: 0 0.5px 0 1px rgba(0, 0, 0, 0.16);\n        border-radius: 16px;\n        padding: 4px 18px;\n        margin-right: 7px;\n        margin-bottom: 7px;\n\n        img {\n          width: 15px;\n          height: 15px;\n        }\n      }\n    }\n\n    .bl-ticket-order-private-note-wrap {\n      border: 1px solid #d7d7d7;\n      box-sizing: border-box;\n      border-radius: 3px;\n      padding: 10px 12px 4px 20px;\n      position: relative;\n      margin-bottom: 16px;\n\n      .bl-ticket-order-pnote-header {\n        display: inline-block;\n        position: absolute;\n        top: -10px;\n        background-color: white;\n        color: #828282;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 20px;\n        ",
        ";\n      }\n\n      .bl-ticket-order-pnote-content {\n        font-weight: 300;\n        font-size: 12px;\n        line-height: 21px;\n      }\n    }\n\n    .bl-ticket-order-price {\n      display: flex;\n\n      .bl-ticket-order-price-title {\n        font-weight: 400;\n        font-size: 15px;\n        line-height: 22px;\n        white-space: nowrap;\n      }\n\n      .bl-ticket-order-price-line {\n        border-style: dashed;\n        width: 100%;\n        margin-left: 0;\n        margin-right: 0;\n      }\n\n      .bl-ticket-order-price-cost {\n      }\n    }\n\n    .bl-ticket-order-after-disc-line {\n    }\n\n    .bl-ticket-order-gtotal {\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 20px;\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 19px;\n\n      .bl-ticket-order-gtotal-title {\n      }\n\n      .bl-ticket-order-gtotal-price {\n      }\n    }\n\n    .bl-ticket-order-checkboxes {\n      label {\n        display: flex;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        align-items: baseline;\n        margin-bottom: 10px;\n\n        input[type='checkbox'] {\n          margin-right: 8px;\n          line-height: 20px;\n          width: 12px;\n          height: 12px;\n          accent-color: #ea475c;\n          border-radius: 2px;\n          ",
        ";\n        }\n      }\n    }\n\n    .bl-ticket-order-pay-btn {\n      background: linear-gradient(137.27deg, #ea475c 19.41%, #ff6175 65.49%);\n      box-shadow: 0px 4px 4px rgba(14, 53, 191, 0.25);\n      border-radius: 12px;\n      color: #f6f6f6;\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 20px;\n\n      padding: 12px 109px;\n      margin: auto;\n      display: block;\n      margin-top: 29px;\n\n      &:active {\n        opacity: 0.9;\n      }\n\n      &:disabled {\n        background: #8b8b8b;\n      }\n    }\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MainWrap",
    componentId: "sc-84e67df1-0"
})(styles_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: 26px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin: 0 8px;" : "");
});

;// CONCATENATED MODULE: ./components/ticketingNew/components/OrderDetailsBlock/index.tsx





















var StripePaymentButton = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9101), __webpack_require__.e(1323)]).then(__webpack_require__.bind(__webpack_require__, 67838));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67838)
            ];
        }
    },
    ssr: false
});
var OrderDetailsBlock = function(props) {
    var participants = props.participants, setOrderLink = props.setOrderLink, setOrderStage = props.setOrderStage, handlePaymentSuccess = props.handlePaymentSuccess, match = props.match, tourId = props.tourId, matterId = props.matterId, initialTourType = props.initialTourType, initialTicketId = props.initialTicketId, gameId = props.gameId;
    var ticketing = (0,store/* useRecoilValue */.sJ)(store/* ticketingDataState */.$W);
    var ticketingGeneral = ticketing.ticketingGeneral;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _plane_name = ref.plane_name, plane_name = _plane_name === void 0 ? "Plane name" : _plane_name, _available_for = ref.available_for, available_for = _available_for === void 0 ? "Available for" : _available_for, _private_note = ref.private_note, private_note = _private_note === void 0 ? "private Note" : _private_note, _ticket = ref.ticket, ticket = _ticket === void 0 ? "ticket" : _ticket, _grand_total = ref.grand_total, grand_total = _grand_total === void 0 ? "Grand Total" : _grand_total, _legal_checkbox_2 = ref.legal_checkbox_2, legal_checkbox_2 = _legal_checkbox_2 === void 0 ? "Legal checkbox 2" : _legal_checkbox_2, _legal_checkbox_1 = ref.legal_checkbox_1, legal_checkbox_1 = _legal_checkbox_1 === void 0 ? "*I agree terms & conditions" : _legal_checkbox_1, _proceed_to_payment = ref.proceed_to_payment, proceed_to_payment = _proceed_to_payment === void 0 ? "Proceed to payment" : _proceed_to_payment, _devices = ref.devices, devices = _devices === void 0 ? "devices" : _devices, _day = ref.day, day = _day === void 0 ? "day" : _day, _days = ref.days, days = _days === void 0 ? "days" : _days, _hour = ref.hour, hour = _hour === void 0 ? "hour" : _hour, _hours = ref.hours, hours = _hours === void 0 ? "hours" : _hours, _min = ref.min, min = _min === void 0 ? "min" : _min, _mins = ref.mins, mins = _mins === void 0 ? "mins" : _mins, _from_purchase = ref.from_purchase, from_purchase = _from_purchase === void 0 ? "from purchase" : _from_purchase, _from_login = ref.from_login, from_login = _from_login === void 0 ? "from login" : _from_login, _max_participants = ref.max_participants, max_participants = _max_participants === void 0 ? "Max. participants" : _max_participants, _tour_language = ref.tour_language, tour_language = _tour_language === void 0 ? "Tour language" : _tour_language, _wrong_discount_val = ref.wrong_discount_val, wrong_discount_val = _wrong_discount_val === void 0 ? "wrong discount value" : _wrong_discount_val, _user = ref.user, user = _user === void 0 ? "user" : _user, _email = ref.email, email = _email === void 0 ? "email" : _email, _name = ref.name, name = _name === void 0 ? "name" : _name, _is_required = ref.is_required, is_required = _is_required === void 0 ? "is required" : _is_required, _is_not_valid = ref.is_not_valid, is_not_valid = _is_not_valid === void 0 ? "is not valid" : _is_not_valid, _check_out = ref.check_out, check_out = _check_out === void 0 ? "Check Out" : _check_out, _tickets_order_was_cancelled = ref.tickets_order_was_cancelled, tickets_order_was_cancelled = _tickets_order_was_cancelled === void 0 ? "Tickets order was cancelled" : _tickets_order_was_cancelled, _tickets_order_error = ref.tickets_order_error, tickets_order_error = _tickets_order_error === void 0 ? "Tickets order error." : _tickets_order_error;
    var ref1 = (0,react.useState)(null), appliedDiscount = ref1[0], setAppliedDiscount = ref1[1];
    //----------- order data fields --------------
    var ref2 = (0,react.useState)(false), checkbox1 = ref2[0], setCheckbox1 = ref2[1];
    var ref3 = (0,react.useState)(false), checkbox2 = ref3[0], setCheckbox2 = ref3[1];
    //----------- order data fields end --------------
    var ref4 = (0,react.useState)(false), ticketOrderSent = ref4[0], setTicketOrderSent = ref4[1];
    //ticketType: "gameTour"
    var tourType = match.params.tourType || (initialTourType === null || initialTourType === void 0 ? void 0 : initialTourType.replace("gameTour", "experienceTour"));
    var ticketId = match.params.ticketId || initialTicketId;
    var tourTypeKey = util/* ticketingTypes */.pb === null || util/* ticketingTypes */.pb === void 0 ? void 0 : util/* ticketingTypes.find */.pb.find(function(tt) {
        return tt.tourType === tourType;
    });
    var ticketingType = tourTypeKey.key;
    var currentTicket = ticketId ? ticketing[tourTypeKey === null || tourTypeKey === void 0 ? void 0 : tourTypeKey.key].find(function(ticket) {
        return ticket.id === parseInt(ticketId);
    }) : null;
    var currencySymbol = ticketingNew_static/* initialCurrency.find */.Z.find(function(cur) {
        return cur.id === ticketingGeneral.currencyId;
    });
    var orderId = (0,react.useRef)(null);
    var orderBtn = (0,react.useRef)(null);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref5[0], setInfoModalData = ref5[1];
    var setTicketOrderResult = (0,store/* useSetRecoilState */.Zl)(store/* orderedTicketsState */.jF);
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* redirectTicketsState */.Sy), 2), redirectTickets = ref6[0], setRedirectTickets = ref6[1];
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var finishOrderRes, ticketsString, tickets;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!redirectTickets) return [
                            3,
                            2
                        ];
                        console.log("redirectTickets", redirectTickets);
                        return [
                            4,
                            TreedisPublicDAO/* default.finishOrderTickets */.Z.finishOrderTickets({
                                /// TODO add transaction to validate
                                orderCode: redirectTickets.orderCode,
                                status: redirectTickets.status,
                                pelecardStatusCode: redirectTickets.PelecardStatusCode,
                                matterId: matterId
                            })
                        ];
                    case 1:
                        finishOrderRes = _state.sent();
                        if (finishOrderRes && finishOrderRes.message.includes("Success")) {
                            if (finishOrderRes.status === "success") {
                                ticketsString = redirectTickets.data;
                                if (ticketsString) {
                                    (0,analytic/* sendToGA */.o$)("event", {
                                        eventCategory: "Ticketing",
                                        eventAction: "purchase",
                                        eventLabel: tourType
                                    });
                                    tickets = JSON.parse(ticketsString);
                                    setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, finishOrderRes === null || finishOrderRes === void 0 ? void 0 : finishOrderRes.order), {
                                        tickets: tickets
                                    }));
                                    handlePaymentSuccess();
                                }
                            } else if (finishOrderRes.status === "cancel") {
                                setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                                    isOpen: true,
                                    message: tickets_order_was_cancelled,
                                    mode: InfoModal/* EInfoModal.error */.Y.error
                                }));
                            } else if (finishOrderRes.status === "error") {
                                setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                                    isOpen: true,
                                    message: "".concat(tickets_order_error, " ").concat(redirectTickets.PelecardStatusCode ? "PelecardStatusCode - ".concat(redirectTickets.PelecardStatusCode) : ""),
                                    mode: InfoModal/* EInfoModal.error */.Y.error
                                }));
                            }
                        }
                        _state.label = 2;
                    case 2:
                        setRedirectTickets(null);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        redirectTickets
    ]);
    (0,react.useEffect)(function() {
        if (!(ticketingGeneral === null || ticketingGeneral === void 0 ? void 0 : ticketingGeneral.paymentType)) {
            setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                isOpen: true,
                message: "Looks like ticketing payment method not set or missing. Please check ticketing -> Payment API on admin panel"
            }));
        }
    }, []);
    var applyDiscounts = function(value) {
        var result = value;
        if (!appliedDiscount) return result;
        if (appliedDiscount.discountType === "currency") {
            if (appliedDiscount.amount > 0) result -= appliedDiscount.amount;
            else setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                isOpen: true,
                message: wrong_discount_val,
                mode: InfoModal/* EInfoModal.error */.Y.error
            }));
        } else if (appliedDiscount.discountType === "percent") {
            if (appliedDiscount.amount > 0 && appliedDiscount.amount <= 100) result -= result * appliedDiscount.amount / 100;
            else setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                isOpen: true,
                message: wrong_discount_val,
                mode: InfoModal/* EInfoModal.error */.Y.error
            }));
        }
        if (result < 0) return 0;
        return result;
    };
    var totalPrice = currentTicket ? parseFloat(applyDiscounts(participants.length * currentTicket.ticketPrice).toFixed(2)) : 0;
    var _validateUsers = function() {
        var noToast = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var errors = [];
        if (ticketingGeneral.legalCheckbox1Required && !checkbox1) errors.push("".concat(legal_checkbox_1, " ").concat(is_required));
        if (ticketingGeneral.legalCheckbox2Required && !checkbox2) errors.push("".concat(legal_checkbox_2, " ").concat(is_required));
        participants.forEach(function(ticket, num) {
            if (!ticket.email.length) {
                errors.push("".concat(user, " ").concat(num + 1, " ").concat(email, " ").concat(is_required));
            } else if (!(0,util_all/* validateEmail */.oH)(ticket.email)) {
                errors.push("".concat(user, " ").concat(num + 1, " ").concat(email, " ").concat(is_not_valid));
            }
            if (!ticket.fullName) errors.push("".concat(user, " ").concat(num + 1, " ").concat(name, " ").concat(is_required));
        });
        if (errors.length) {
            if (!noToast) react_toastify_esm/* toast.error */.Am.error(errors.join("\n"));
            return 1;
        }
        return 0;
    };
    var handleProceedPayment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, body, data, order, ticketPayRes, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            5,
                            6
                        ]);
                        if (orderBtn === null || orderBtn === void 0 ? void 0 : (ref = orderBtn.current) === null || ref === void 0 ? void 0 : ref.disabled) return [
                            2
                        ];
                        //validation here
                        if (_validateUsers()) return [
                            2
                        ];
                        setTicketOrderSent(true);
                        body = {
                            paymentType: ticketingGeneral.paymentType,
                            ticketType: tourType.replace("experienceTour", "gameTour"),
                            tourId: tourId,
                            matterId: matterId,
                            participants: participants.map(function(participant) {
                                //fullName: '', email: '', isGift: false
                                var fullName = participant.fullName, email = participant.email, isGift = participant.isGift;
                                if (!fullName && !email && !isGift && participants[0]) {
                                    fullName = participants[0].fullName;
                                    email = participants[0].email;
                                    isGift = participants[0].isGift;
                                }
                                return {
                                    name: fullName,
                                    email: email,
                                    gift: isGift
                                };
                            }),
                            selectedTicketId: currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.id,
                            discountCode: appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.codeName,
                            goodUrl: location.origin,
                            cancelUrl: location.origin,
                            errorUrl: location.origin,
                            amount: totalPrice,
                            // notificationGoodMail,
                            // notificationErrorMail,
                            // notificationFailMail,
                            currency: (currencySymbol === null || currencySymbol === void 0 ? void 0 : currencySymbol.code) || "USD"
                        };
                        return [
                            4,
                            TreedisPublicDAO/* default.createTicketOrder */.Z.createTicketOrder(body)
                        ];
                    case 1:
                        data = _state.sent().data;
                        order = data.order;
                        orderId.current = order === null || order === void 0 ? void 0 : order.id;
                        if (!(ticketingGeneral.paymentType === Order/* TicketPaymentType.Pelecard */.fx.Pelecard || Number(totalPrice) === 0)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            TreedisPublicDAO/* default.payTickets */.Z.payTickets(ticketingGeneral.paymentType || Order/* TicketPaymentType.NoPayment */.fx.NoPayment, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, body), {
                                orderId: order.id
                            }))
                        ];
                    case 2:
                        ticketPayRes = _state.sent();
                        if (ticketPayRes && ticketPayRes.message.includes("Success")) {
                            if (ticketPayRes.ticketsWithoutCost) {
                                console.log("ticketPayRes", ticketPayRes);
                                setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketPayRes), {
                                    gameId: gameId
                                }));
                                handlePaymentSuccess();
                            } else {
                                setOrderLink(ticketPayRes.url);
                                setOrderStage(Order/* OrderStageEnum.payment */.t9.payment);
                            }
                        }
                        _state.label = 3;
                    case 3:
                        setTicketOrderSent(false);
                        return [
                            2,
                            {
                                ticketOrderId: order.id,
                                name: participants[0].fullName,
                                email: participants[0].email
                            }
                        ];
                    case 4:
                        err = _state.sent();
                        setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                            isOpen: true,
                            message: err.message,
                            mode: InfoModal/* EInfoModal.error */.Y.error
                        }));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setTicketOrderSent(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleProceedPayment() {
            return _ref.apply(this, arguments);
        };
    }();
    var cancelOrder = function() {
        setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: true,
            message: "Error paypal payment",
            mode: InfoModal/* EInfoModal.error */.Y.error
        }));
    };
    var paypalCreateOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data, actions) {
            var ticketOrderId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleProceedPayment()
                        ];
                    case 1:
                        ticketOrderId = _state.sent().ticketOrderId;
                        console.log("ticketOrderId", ticketOrderId);
                        if (!ticketOrderId) throw new Error("No order ID");
                        orderId.current = ticketOrderId;
                        return [
                            2,
                            actions.order.create({
                                purchase_units: [
                                    {
                                        amount: {
                                            value: totalPrice,
                                            currency_code: currencySymbol.code
                                        }
                                    }
                                ]
                            })
                        ];
                }
            });
        });
        return function paypalCreateOrder(data, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    var paypalApproveOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data, actions) {
            var ticketPayRes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TreedisPublicDAO/* default.payTickets */.Z.payTickets(ticketingGeneral.paymentType, {
                                data: {
                                    orderId: orderId.current,
                                    paymentId: data.orderID
                                }
                            })
                        ];
                    case 1:
                        ticketPayRes = _state.sent();
                        if (!ticketPayRes) return [
                            2,
                            setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                                isOpen: true,
                                message: "Error paypal payment - orderId: ".concat(data.orderID),
                                mode: InfoModal/* EInfoModal.error */.Y.error
                            }))
                        ];
                        console.log("ticketPayRes", ticketPayRes);
                        setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketPayRes), {
                            gameId: gameId
                        }));
                        handlePaymentSuccess();
                        return [
                            2
                        ];
                }
            });
        });
        return function paypalApproveOrder(data, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    var stripeCreateOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ticketOrderId, name, email, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            handleProceedPayment()
                        ];
                    case 1:
                        ref = _state.sent(), ticketOrderId = ref.ticketOrderId, name = ref.name, email = ref.email;
                        if (!ticketOrderId) throw new Error();
                        return [
                            2,
                            {
                                id: ticketOrderId,
                                totalPrice: totalPrice,
                                currency: currencySymbol.code,
                                name: name,
                                email: email,
                                tourId: tourId
                            }
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function stripeCreateOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var approveOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ticketPayRes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TreedisPublicDAO/* default.payTickets */.Z.payTickets(ticketingGeneral.paymentType, {
                                data: {
                                    orderId: orderId.current
                                }
                            })
                        ];
                    case 1:
                        ticketPayRes = _state.sent();
                        console.log("ticketPayRes", ticketPayRes);
                        if (!ticketPayRes) return [
                            2
                        ];
                        setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketPayRes), {
                            gameId: gameId
                        }));
                        handlePaymentSuccess();
                        return [
                            2
                        ];
                }
            });
        });
        return function approveOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var durationLabels = [
        [
            [
                day
            ],
            [
                days
            ]
        ],
        [
            [
                hour
            ],
            [
                hours
            ]
        ],
        [
            [
                min
            ],
            [
                mins
            ]
        ], 
    ];
    var formatTicketTime = function(duration) {
        var durtionMinLeft = duration;
        var durationDays = parseInt(String(durtionMinLeft / (24 * 60)), 10);
        durtionMinLeft -= durationDays * 60 * 24;
        var durationHours = parseInt(String(durtionMinLeft / 60), 10);
        durtionMinLeft -= durationHours * 60;
        return [
            durationDays,
            durationHours,
            durtionMinLeft
        ];
    };
    var ref7 = currentTicket || {}, durationType = ref7.durationType, limitDevices = ref7.limitDevices, duration = ref7.duration, maxParticipants = ref7.maxParticipants, tourLanguage = ref7.tourLanguage, ticketPrice = ref7.ticketPrice;
    var pillsList = [];
    if (durationType) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/ticketing/clock.svg",
                    alt: "clock-icon"
                }),
                formatTicketTime(duration).map(function(durationPart, num) {
                    if (durationPart) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                durationPart,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: durationPart === 1 ? durationLabels[num][0] : durationLabels[num][1]
                                }),
                                "\xa0"
                            ]
                        }, num);
                    }
                    return null;
                }),
                " ",
                durationType === types/* DurationType.from_purchase */.q.from_purchase ? from_purchase : from_login
            ]
        }, "durationType"));
    }
    if (limitDevices) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/ticketing/desktopMobile.svg",
                    alt: "desktop-mobile-icon"
                }),
                " ",
                limitDevices,
                " ",
                devices
            ]
        }, "limitDevices"));
    }
    if (maxParticipants) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas fa-user-friends"
                }),
                max_participants,
                " ",
                maxParticipants
            ]
        }, "maxParticipants"));
    }
    if (tourLanguage) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fal fa-globe"
                }),
                tour_language,
                " ",
                tourLanguage
            ]
        }, "tourLanguage"));
    }
    if (ticketPrice) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fal fa-tag"
                }),
                ticketPrice,
                currencySymbol.symbol
            ]
        }, "ticketPrice"));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
        className: "bl-ticket-order",
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-ticket-order-title",
                children: plane_name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-subTitle",
                children: [
                    available_for,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-ticket-order-pills",
                children: pillsList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-private-note-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-order-pnote-header",
                        children: private_note
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-order-pnote-content",
                        dangerouslySetInnerHTML: {
                            __html: currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.description
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-price",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-order-price-title",
                        children: [
                            participants.length,
                            " ",
                            ticket,
                            " X ",
                            currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.ticketPrice,
                            " ",
                            currencySymbol.code
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "bl-ticket-order-price-line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-order-price-cost",
                        children: [
                            participants.length * (currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.ticketPrice) || 0,
                            currencySymbol.symbol
                        ]
                    })
                ]
            }),
            currentTicket && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DiscountField, {
                tourId: tourId,
                ticketId: ticketId,
                ticketingType: ticketingType,
                currencySign: currencySymbol.symbol,
                onDiscountApply: setAppliedDiscount
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "bl-ticket-order-after-disc-line"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-gtotal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-order-gtotal-title",
                        children: grand_total
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-order-gtotal-price",
                        children: [
                            totalPrice,
                            currencySymbol.symbol
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-checkboxes",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                checked: checkbox1,
                                onChange: function() {
                                    return setCheckbox1(!checkbox1);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: ticketingGeneral.termsAndConditionsUrl,
                                target: "_blank",
                                children: legal_checkbox_1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                checked: checkbox2,
                                onChange: function() {
                                    return setCheckbox2(!checkbox2);
                                }
                            }),
                            legal_checkbox_2
                        ]
                    })
                ]
            }),
            ticketingGeneral && currentTicket && (ticketingGeneral.paymentType === Order/* TicketPaymentType.Pelecard */.fx.Pelecard || !ticketingGeneral.paid || totalPrice === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                ref: orderBtn,
                disabled: ticketOrderSent,
                className: "bl-ticket-order-pay-btn",
                onClick: handleProceedPayment,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas icon"
                    }),
                    proceed_to_payment
                ]
            }),
            !_validateUsers(true) && ticketingGeneral && currentTicket && ticketingGeneral.paymentType === Order/* TicketPaymentType.Stripe */.fx.Stripe && totalPrice !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StripePaymentButton, {
                translation: {
                    check_out: check_out
                },
                createOrder: stripeCreateOrder,
                settings: ticketingGeneral,
                approveOrder: approveOrder
            }),
            !_validateUsers(true) && (ticketingGeneral === null || ticketingGeneral === void 0 ? void 0 : ticketingGeneral.apiUsername) && currencySymbol.code && currentTicket && ticketingGeneral.paymentType === Order/* TicketPaymentType.Paypal */.fx.Paypal && totalPrice !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ch-btn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* PayPalButton */.q, {
                    shippingPreference: "NO_SHIPPING",
                    currency: currencySymbol.code,
                    options: {
                        clientId: ticketingGeneral === null || ticketingGeneral === void 0 ? void 0 : ticketingGeneral.apiUsername,
                        currency: currencySymbol.code
                    },
                    style: {
                        color: "silver"
                    },
                    createOrder: paypalCreateOrder,
                    onApprove: paypalApproveOrder,
                    onError: cancelOrder
                })
            })
        ]
    });
};
/* harmony default export */ var components_OrderDetailsBlock = (OrderDetailsBlock);


/***/ }),

/***/ 30510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18533);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 38px;\n\n  .bl-steps-wrap {\n    width: 202px;\n    display: flex;\n    justify-content: space-between;\n\n    .step {\n      color: white;\n      width: 48px;\n      height: 48px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: #bbbbbb;\n      font-weight: 400;\n      font-size: 32px;\n      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n      border-radius: 50%;\n      z-index: 2;\n\n      &.active {\n        background-color: #4b4b4b;\n      }\n\n      &.done {\n        background-color: #ea475c;\n      }\n    }\n  }\n\n  hr {\n    position: absolute;\n    top: 10px;\n    width: 172px;\n    border: 1px solid #8e8e8e;\n    z-index: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "StepsBlock__MainWrap",
    componentId: "sc-78f40250-0"
})(_templateObject());
var StepsBlock = function(props) {
    var count = props.count, active = props.active, _done = props.done, done = _done === void 0 ? [] : _done;
    var steps = [];
    for(var i = 0; i < count; i++)steps.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("step", active === i + 1 && "active", done.includes(i + 1) && "done"),
        children: done.includes(i + 1) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
            className: "fas fa-check"
        }) : i + 1
    }, i));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        className: "bl-steps-widget",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "bl-steps-wrap",
                children: steps
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StepsBlock);


/***/ }),

/***/ 47238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16592);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98592);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18533);
/* harmony import */ var _components_ticketingNew_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84345);
/* harmony import */ var _components_ticketingNew_static__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70712);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12781);
/* harmony import */ var _utils_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14045);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_ticketingNew_components_MoreInfoBtn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72225);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: 15px;\n  min-height: 134px;\n\n  .bl-tm-first {\n    background: #ffffff;\n    border-radius: 0 10px 10px 0;\n    width: 108px;\n    min-width: 108px;\n    padding: 5px;\n    text-align: center;\n    ",
        ";\n\n    .bl-tm-first-title {\n      margin-top: 6px;\n      margin-bottom: 9px;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 18px;\n    }\n\n    .bl-tm-first-price {\n      font-weight: 500;\n      font-size: 30px;\n      line-height: 45px;\n      margin-bottom: 10px;\n    }\n\n    .bl-tm-first-start-btn {\n      background: #ea475c;\n      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);\n      border-radius: 6px;\n      color: white;\n      width: 89px;\n      height: 28px;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 18px;\n\n      i {\n        margin-left: 7px;\n      }\n\n      &:active {\n        opacity: 0.9;\n      }\n    }\n\n    .tim-radio-pick-wrap {\n      display: flex;\n      height: 23px;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      color: #a5a5a5;\n      font-weight: 600;\n      font-size: 15px;\n\n      &.picked {\n        color: #ea475c;\n      }\n\n      input {\n        width: 17px;\n        height: 17px;\n        margin-left: 5px;\n      }\n    }\n  }\n\n  .bl-tm-second {\n    overflow: hidden;\n    width: 100%;\n    margin-left: 1px;\n    padding: 5px;\n    background: #ffffff;\n    border-radius: 10px 0 0 10px;\n    position: relative;\n    ",
        ";\n\n    .bl-tm-second-desc {\n      min-height: 36px;\n      padding: 8px 10px 0 10px;\n      font-weight: 300;\n      font-size: 12px;\n      line-height: 18px;\n      max-height: 65px;\n\n      text-align: left;\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .bl-tm-second-info-title {\n      font-weight: 300;\n      font-size: 12px;\n      line-height: 18px;\n      text-decoration-line: underline;\n      color: #969595;\n      margin-left: 10px;\n      margin-top: 7px;\n    }\n\n    .bl-tm-second-info-wrap {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      justify-content: left;\n      margin-top: 7px;\n      padding: 0 2px;\n\n      .bl-tm-second-info-item {\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #333333;\n        display: flex;\n        align-items: center;\n\n        img {\n          width: 18px;\n          height: 18px;\n          margin-right: 3px;\n        }\n      }\n\n      hr {\n        margin: 0 10px;\n        height: 13px;\n        border: none;\n        border-left: 1px solid black;\n\n        &:last-child {\n          display: none;\n        }\n      }\n    }\n\n    .bl-ticket-ending {\n      position: absolute;\n      height: 134px;\n      right: 0;\n      top: 0;\n      ",
        ";\n\n      .bl-ticket-end-rect {\n        width: 12px;\n        height: 16px;\n        background: #e5e5e5;\n        border-radius: 12px 0 0 12px;\n\n        &.bl-rect-1 {\n          margin-top: 27px;\n        }\n\n        &.bl-rect-2 {\n          margin-top: 15px;\n        }\n\n        &.bl-rect-3 {\n          margin-top: 15px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "TicketItemMobile__MainWrap",
    componentId: "sc-6a7035b7-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "border-radius: 10px 0 0 10px;margin-left: 3px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "border-radius: 0 10px 10px 0;padding-left: 13px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "left: 0;right: initial;transform: scale(-1, 1);" : "");
});
var TicketItemMobile = function(props) {
    var ticket = props.ticket, currencyId = props.currencyId, match = props.match, onPick = props.onPick, pickedId = props.pickedId;
    var durationType = ticket.durationType, limitDevices = ticket.limitDevices, duration = ticket.duration, maxParticipants = ticket.maxParticipants, tourLanguage = ticket.tourLanguage, ticketInfoUlr = ticket.ticketInfoUlr;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_5__/* .translationDataState */ .Jv), _available_for = ref.available_for, available_for = _available_for === void 0 ? "Available for" : _available_for, _start = ref.start, start = _start === void 0 ? "start" : _start, _devices = ref.devices, devices = _devices === void 0 ? "devices" : _devices, _day = ref.day, day = _day === void 0 ? "day" : _day, _days = ref.days, days = _days === void 0 ? "days" : _days, _hour = ref.hour, hour = _hour === void 0 ? "hour" : _hour, _hours = ref.hours, hours = _hours === void 0 ? "hours" : _hours, _min = ref.min, min = _min === void 0 ? "min" : _min, _mins = ref.mins, mins = _mins === void 0 ? "mins" : _mins, _from_purchase = ref.from_purchase, from_purchase = _from_purchase === void 0 ? "from purchase" : _from_purchase, _from_login = ref.from_login, from_login = _from_login === void 0 ? "from login" : _from_login, _max_participants = ref.max_participants, max_participants = _max_participants === void 0 ? "Max. participants" : _max_participants, _tour_language = ref.tour_language, tour_language = _tour_language === void 0 ? "Tour language" : _tour_language, _picked = ref.picked, picked = _picked === void 0 ? "Picked" : _picked, _pick = ref.pick, pick = _pick === void 0 ? "Pick" : _pick;
    var rtl = (0,_store__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_5__/* .tourConfigsState */ .Uq).rtl;
    var tourType = match.params.tourType;
    var durationLabels = [
        [
            [
                day
            ],
            [
                days
            ]
        ],
        [
            [
                hour
            ],
            [
                hours
            ]
        ],
        [
            [
                min
            ],
            [
                mins
            ]
        ], 
    ];
    var formatTicketTime = function(duration) {
        var durtionMinLeft = duration;
        var durationDays = parseInt(String(durtionMinLeft / (24 * 60)), 10);
        durtionMinLeft -= durationDays * 60 * 24;
        var durationHours = parseInt(String(durtionMinLeft / 60), 10);
        durtionMinLeft -= durationHours * 60;
        return [
            durationDays,
            durationHours,
            durtionMinLeft
        ];
    };
    var currencySymbol = _components_ticketingNew_static__WEBPACK_IMPORTED_MODULE_4__/* .initialCurrency.find */ .Z.find(function(cur) {
        return cur.id === currencyId;
    });
    var infoItems = [];
    if (durationType) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: "/ticketing/clock.svg",
                    alt: "clock-icon"
                }),
                formatTicketTime(duration).map(function(durationPart, num) {
                    if (durationPart) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                            children: [
                                durationPart,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    children: durationPart === 1 ? durationLabels[num][0] : durationLabels[num][1]
                                }),
                                "\xa0"
                            ]
                        }, num);
                    }
                    return null;
                }),
                " ",
                durationType === _components_ticketingNew_types__WEBPACK_IMPORTED_MODULE_3__/* .DurationType.from_purchase */ .q.from_purchase ? from_purchase : from_login
            ]
        }, "durationType_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "durationType_hr"));
    }
    if (limitDevices) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: "/ticketing/desktopMobile.svg",
                    alt: "desktop-mobile-icon"
                }),
                " ",
                limitDevices,
                " ",
                devices
            ]
        }, "limitDevices_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "limitDevices_hr"));
    }
    if (maxParticipants) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                    className: "fas fa-user-friends"
                }),
                max_participants,
                " ",
                maxParticipants
            ]
        }, "maxParticipants_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "maxParticipants_hr"));
    }
    if (tourLanguage) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                    className: "fal fa-globe"
                }),
                tour_language,
                " ",
                tourLanguage
            ]
        }, "tourLanguage_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "tourLanguage_hr"));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bl-tm-first",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bl-tm-first-title",
                        children: ticket.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "bl-tm-first-price",
                        children: [
                            ticket.ticketPrice,
                            currencySymbol.symbol
                        ]
                    }),
                    !onPick ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .rU, {
                        to: "".concat(tourType, "/").concat(ticket.id),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                            className: "bl-tm-first-start-btn",
                            children: [
                                (0,_utils_string__WEBPACK_IMPORTED_MODULE_6__/* .capitalize */ .kC)(start),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                    className: "fas fa-chevron-right"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()("tim-radio-pick-wrap", ticket.id === pickedId && "picked"),
                        children: [
                            ticket.id === pickedId ? picked : pick,
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                type: "radio",
                                onChange: function() {
                                    return onPick(ticket.id);
                                },
                                checked: ticket.id === pickedId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bl-tm-second",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bl-tm-second-desc",
                        dangerouslySetInnerHTML: {
                            __html: ticket.description
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "bl-tm-second-info-title",
                        children: [
                            available_for,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bl-tm-second-info-wrap",
                        children: infoItems
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "bl-ticket-ending",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ticketingNew_components_MoreInfoBtn__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        ticketInfoUlr: ticketInfoUlr
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_router_dom__WEBPACK_IMPORTED_MODULE_11__/* .withRouter */ .EN)(TicketItemMobile));


/***/ }),

/***/ 70883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18533);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12781);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 133px;\n  background-color: #282828;\n  position: relative;\n\n  .bl-minimized-vector {\n    width: 0;\n    height: 0;\n    right: 0;\n    top: 0;\n    position: absolute;\n    border-bottom: 133px solid #ea475c;\n    border-left: 241px solid transparent;\n  }\n\n  .bl-minimized-title {\n    margin: 0;\n    height: 100%;\n    padding: 0 300px 0 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    //margin-top: 38px;\n    //margin-left: 80px;\n    font-weight: 400;\n    font-size: 40px;\n    line-height: 60px;\n    color: white;\n    position: absolute;\n    //max-height: calc(100% - 38px);\n    overflow: hidden;\n\n    @media screen and (max-width: 760px) {\n      width: 100%;\n      text-align: center;\n      margin-left: 0;\n    }\n  }\n\n  @media screen and (max-width: 760px) {\n    height: 77px;\n    .bl-minimized-title {\n      padding: inherit;\n      margin: 0;\n\n      text-align: left;\n      font-style: normal;\n      font-weight: 500;\n      font-size: 22px;\n      line-height: 33px;\n      //margin-top: 20px;\n      //padding-left: 24px;\n      //max-height: calc(100% - 20px);\n    }\n    .bl-minimized-vector {\n      border-right: 84px solid #ea475c;\n      border-bottom: 77px solid transparent;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "TourImageDescriptionMinized__MainWrap",
    componentId: "sc-255bc9f8-0"
})(_templateObject());
var TourImageDescriptionMinized = function() {
    var ticketingGeneral = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .ticketingDataState */ .$W).ticketingGeneral;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "bl-minimized-vector"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "bl-minimized-title",
                dangerouslySetInnerHTML: {
                    __html: ticketingGeneral.title
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TourImageDescriptionMinized);


/***/ }),

/***/ 67020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t9": function() { return /* binding */ OrderStageEnum; },
  "fx": function() { return /* binding */ TicketPaymentType; },
  "ZP": function() { return /* binding */ pages_Order; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./components/ticketingNew/components/TourImageDescriptionMinized.tsx
var TourImageDescriptionMinized = __webpack_require__(70883);
// EXTERNAL MODULE: ./components/ticketingNew/components/StepsBlock.tsx
var StepsBlock = __webpack_require__(30510);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/react-switch/dist/index.prod.mjs
var index_prod = __webpack_require__(45810);
// EXTERNAL MODULE: ./utils/string.ts
var string = __webpack_require__(14045);
;// CONCATENATED MODULE: ./components/ticketingNew/components/UserCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bl-ticket-item {\n    height: 141px;\n    display: flex;\n    margin-bottom: 11px;\n\n    .bl-ticket-desc {\n      width: 108px;\n      min-width: 108px;\n      background: #ffffff;\n      border-radius: 0 12px 12px 0;\n      margin-right: 3px;\n      filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.14));\n      text-align: center;\n      position: relative;\n      ",
        ";\n\n      .bl-ticket-number-text {\n        margin-top: 17px;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 21px;\n      }\n\n      .bl-ticket-number {\n        font-weight: 400;\n        font-size: 60px;\n        line-height: 90px;\n      }\n\n      .bl-ticket-triangle {\n        width: 0;\n        height: 0;\n        border-bottom: 29px solid #ea475c;\n        border-right: 49px solid transparent;\n        position: absolute;\n        bottom: 0;\n        ",
        ";\n      }\n    }\n\n    .bl-ticket-data {\n      padding-top: 29px;\n      padding-left: 20px;\n      padding-right: 54px;\n      width: 100%;\n      background: #ffffff;\n      border-radius: 12px 0 0 12px;\n      filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.14));\n      ",
        ";\n\n      label {\n        display: flex;\n        font-weight: 400;\n        font-size: 15px;\n        line-height: 22px;\n        margin-bottom: 19px;\n        justify-content: space-between;\n\n        span {\n          ",
        ";\n        }\n\n        .bl-text-input {\n          height: 23px;\n          width: 251px;\n          border: 1px solid #c4c4c4;\n          box-sizing: border-box;\n          border-radius: 4px;\n\n          &:active,\n          &:focus {\n            outline-color: #c4c4c4;\n          }\n        }\n      }\n\n      .bl-field-2 {\n        label {\n          margin-bottom: 15px;\n        }\n      }\n\n      .bl-field-3 {\n        label {\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 20px;\n          justify-content: space-between;\n          width: 117px;\n          float: right;\n        }\n\n        .bl-field-close {\n          float: left;\n          display: flex;\n          align-items: baseline;\n          cursor: pointer;\n          color: #ea475c;\n          //line-height: 13px;\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 15px;\n\n          .bl-close-circle {\n            width: 13px;\n            height: 13px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background-color: #ea475c;\n            margin: 6px;\n            color: white;\n            border-radius: 50%;\n\n            i {\n              font-weight: normal;\n              font-size: 10px;\n            }\n          }\n        }\n      }\n\n      .bl-ticket-ending {\n        position: absolute;\n        height: 141px;\n        right: 0;\n        top: 0;\n        ",
        ";\n\n        .bl-ticket-end-rect {\n          width: 18px;\n          height: 21px;\n          background: #e5e5e5;\n          border-radius: 12px 0 0 12px;\n\n          &.bl-rect-1 {\n            margin-top: 20px;\n          }\n\n          &.bl-rect-2 {\n            margin-top: 19px;\n          }\n\n          &.bl-rect-3 {\n            margin-top: 19px;\n          }\n        }\n      }\n\n      @media screen and (max-width: 760px) {\n        ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var TicketItemMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UserCard__TicketItemMainWrap",
    componentId: "sc-2dad07d2-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin-left: 3px; margin-right: 0; border-radius: 12px 0 0 12px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "transform: scale(-1, 1); right: -1px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "border-radius: 0 12px 12px 0; padding: 29px 20px 0 54px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right:12px;left:initial!important;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: initial;left: -2px;transform: scale(-1,1);" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "padding-left:20px!important;padding-right: 10px!important;" : "");
});
var UserCard = function(props) {
    var ticket = props.ticket, ticketNum = props.ticketNum, setTicketData = props.setTicketData, removeTicket = props.removeTicket;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _user = ref.user, user = _user === void 0 ? "User" : _user, _full_name = ref.full_name, full_name = _full_name === void 0 ? "Full name" : _full_name, _email = ref.email, email = _email === void 0 ? "Email" : _email, _closeTicket = ref.closeTicket, closeTicket = _closeTicket === void 0 ? "Close" : _closeTicket, _send_as_gift = ref.send_as_gift, send_as_gift = _send_as_gift === void 0 ? "Send as gift" : _send_as_gift;
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TicketItemMainWrap, {
        className: "bl-ticket-item",
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-desc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-number-text",
                        children: [
                            user,
                            " ",
                            ticketNum + 1
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-number",
                        children: ticketNum + 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-triangle"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-data",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-field-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "*",
                                        (0,string/* capitalize */.kC)(full_name)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "bl-text-input",
                                    onChange: function(ev) {
                                        return setTicketData({
                                            id: ticket.id,
                                            target: "fullName",
                                            value: ev.target.value
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-field-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "*",
                                        (0,string/* capitalize */.kC)(email)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "bl-text-input",
                                    onChange: function(ev) {
                                        return setTicketData({
                                            id: ticket.id,
                                            target: "email",
                                            value: ev.target.value
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-field-3",
                        children: [
                            ticketNum > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bl-field-close",
                                onClick: function() {
                                    return removeTicket(ticket.id);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-close-circle",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-times"
                                        })
                                    }),
                                    (0,string/* capitalize */.kC)(closeTicket)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    send_as_gift,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_prod/* default */.Z, {
                                        onColor: "#ea475c",
                                        checked: ticket.isGift,
                                        onChange: function(newIsGift) {
                                            return setTicketData({
                                                id: ticket.id,
                                                target: "isGift",
                                                value: newIsGift
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-ending",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-3"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_UserCard = (UserCard);

// EXTERNAL MODULE: ./components/ticketingNew/components/BackButton.tsx
var BackButton = __webpack_require__(7710);
// EXTERNAL MODULE: ./components/ticketingNew/components/OrderDetailsBlock/index.tsx + 2 modules
var OrderDetailsBlock = __webpack_require__(61749);
;// CONCATENATED MODULE: ./components/ticketingNew/pages/Order/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .bl-signUp-text {\n    text-align: center;\n    font-weight: 500;\n    font-size: 30px;\n    line-height: 45px;\n    margin-top: 20px;\n    margin-bottom: 88px;\n  }\n\n  .bl-ticket-main-wrap {\n    margin-left: 163px;\n    margin-right: 220px;\n    display: flex;\n\n    .bl-tickets-wrap {\n      margin-right: ",
        ";\n      margin-left: ",
        ";\n      width: calc(50% - 16px);\n      display: inline-block;\n\n      .bl-add-ticket-wrap {\n        margin-top: 15px;\n        display: flex;\n        align-items: baseline;\n        cursor: pointer;\n\n        &:active {\n          opacity: 0.8;\n        }\n\n        .bl-add-plus {\n          width: 21px;\n          height: 21px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background: #ea475c;\n          border-radius: 2px;\n          color: white;\n        }\n\n        .bl-add-text {\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 18px;\n          margin-left: 10px;\n          ",
        ";\n        }\n      }\n    }\n  }\n\n  .bl-payment-wrap {\n    height: 466px;\n    width: 582px;\n    margin: auto;\n    cursor: pointer;\n  }\n\n  .ch-btn {\n    text-align: center;\n    margin-top: 37px;\n  }\n\n  @media screen and (max-width: 760px) {\n    .bl-steps-widget {\n      margin-top: 0;\n    }\n\n    .bl-signUp-text {\n      margin-bottom: 0;\n    }\n\n    .bl-ticket-main-wrap {\n      display: flex;\n      flex-direction: column;\n      margin: 15px 22px;\n\n      .bl-ticket-order {\n        width: 100%;\n        padding: 15px;\n\n        .bl-ticket-order-pills {\n          margin-bottom: 14px;\n\n          .bl-ticket-order-pill {\n            margin-bottom: 8px;\n          }\n        }\n\n        .bl-ticket-order-pay-btn {\n          padding: 12px;\n          width: 100%;\n        }\n      }\n\n      .bl-tickets-wrap {\n        width: 100%;\n        margin-bottom: 20px;\n        margin-right: 0;\n\n        .bl-ticket-item {\n          position: relative;\n          display: flex;\n          width: 100%;\n\n          .bl-ticket-desc {\n            width: 83px;\n            min-width: 83px;\n          }\n\n          .bl-ticket-data {\n            padding: 9px 17px 18px 14px;\n            overflow: hidden;\n            //width: auto;\n            width: 100%;\n            padding-right: 27px;\n\n            .bl-field-1 {\n              margin-top: 12px;\n            }\n\n            .bl-field-2 {\n              margin-top: 21px;\n            }\n\n            .bl-field-1,\n            .bl-field-2 {\n              label {\n                position: relative;\n              }\n\n              span {\n                line-height: 1;\n                position: absolute;\n                background: white;\n                top: -12px;\n                left: 12px;\n              }\n\n              input {\n                height: 30px;\n                width: 100%;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .bl-payment-wrap {\n      max-width: 100%;\n\n      img {\n        max-width: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n\n  @media screen and (min-width: 1057px) and (max-width: 1440px) {\n    .bl-ticket-main-wrap {\n      width: 1057px;\n      margin: auto;\n    }\n  }\n  @media screen and (min-width: 760px) and (max-width: 1057px) {\n    .bl-ticket-main-wrap {\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      width: 519px;\n      margin: auto;\n\n      .bl-tickets-wrap {\n        width: 100%;\n      }\n\n      .bl-ticket-order {\n        width: 100%;\n      }\n    }\n  }\n  @media screen and (min-width: 1440px) {\n    .bl-ticket-main-wrap {\n      max-width: 1080px;\n      margin: auto;\n    }\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var OrderMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__OrderMainWrap",
    componentId: "sc-88f0c1f1-0"
})(styled_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "initial" : "16px");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "16px" : "initial");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin: 0 10px;" : "");
});

;// CONCATENATED MODULE: ./components/ticketingNew/pages/Order/index.tsx














var getInitialTicketData = function() {
    return {
        id: Date.now(),
        fullName: "",
        email: "",
        isGift: false
    };
};
var OrderStageEnum;
(function(OrderStageEnum) {
    OrderStageEnum[OrderStageEnum["order"] = 2] = "order";
    OrderStageEnum[OrderStageEnum["payment"] = 3] = "payment";
    OrderStageEnum[OrderStageEnum["tourOrderOnlySuccess"] = 4] = "tourOrderOnlySuccess";
})(OrderStageEnum || (OrderStageEnum = {}));
var TicketPaymentType;
(function(TicketPaymentType) {
    TicketPaymentType["NoPayment"] = "noPayment";
    TicketPaymentType["Paypal"] = "paypal";
    TicketPaymentType["Stripe"] = "stripe";
    TicketPaymentType["Pelecard"] = "pelecard";
})(TicketPaymentType || (TicketPaymentType = {}));
var Order = function(props) {
    var match = props.match, matterId = props.matterId, tourId = props.tourId, gameId = props.gameId;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _add_a_ticket = ref.add_a_ticket, add_a_ticket = _add_a_ticket === void 0 ? "Add a ticket" : _add_a_ticket, _sign_up_process = ref.sign_up_process, sign_up_process = _sign_up_process === void 0 ? "Sign up process" : _sign_up_process, _payment = ref.payment, payment = _payment === void 0 ? "Payment" : _payment;
    var history = (0,react_router/* useHistory */.k6)();
    var ref1 = (0,react.useState)(OrderStageEnum.order), orderStage = ref1[0], setOrderStage = ref1[1];
    var ref2 = (0,react.useState)([
        getInitialTicketData()
    ]), participants = ref2[0], setParticipants = ref2[1];
    var ref3 = (0,react.useState)(""), orderLink = ref3[0], setOrderLink = ref3[1];
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    var handleAddTicket = function() {
        return setParticipants((0,_to_consumable_array/* default */.Z)(participants).concat([
            getInitialTicketData()
        ]));
    };
    var handleSetTicketData = function(props) {
        setParticipants(participants.map(function(ticket) {
            if (ticket.id === props.id) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticket), (0,_define_property/* default */.Z)({}, props.target, props.value));
            return ticket;
        }));
    };
    var handleRemoveTicket = function(id) {
        setParticipants(participants.filter(function(ticket) {
            return ticket.id !== id;
        }));
    };
    var handlePaymentSuccess = function() {
        var ref, ref1;
        if (match === null || match === void 0 ? void 0 : (ref = match.params) === null || ref === void 0 ? void 0 : ref.ticketId) history.push("".concat(match === null || match === void 0 ? void 0 : (ref1 = match.params) === null || ref1 === void 0 ? void 0 : ref1.ticketId, "/success"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderMainWrap, {
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TourImageDescriptionMinized/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                backFunction: orderStage === OrderStageEnum.order ? null : function() {
                    setOrderStage(OrderStageEnum.order);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsBlock/* default */.Z, {
                count: 3,
                active: orderStage,
                done: orderStage === OrderStageEnum.order ? [
                    1
                ] : [
                    1,
                    2
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-signUp-text",
                children: orderStage === OrderStageEnum.order ? sign_up_process : payment
            }),
            orderStage === OrderStageEnum.order ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-main-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-tickets-wrap",
                        children: [
                            participants.map(function(ticket, ticketNum) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserCard, {
                                    ticket: ticket,
                                    ticketNum: ticketNum,
                                    setTicketData: handleSetTicketData,
                                    removeTicket: handleRemoveTicket
                                }, ticket.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bl-add-ticket-wrap",
                                onClick: handleAddTicket,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-add-plus",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-plus"
                                        })
                                    }),
                                    participants.length < 50 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-add-text",
                                        children: add_a_ticket
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailsBlock/* default */.Z, {
                        matterId: matterId,
                        match: match,
                        handlePaymentSuccess: handlePaymentSuccess,
                        participants: participants,
                        setOrderStage: setOrderStage,
                        tourId: tourId,
                        gameId: gameId,
                        setOrderLink: setOrderLink
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-payment-wrap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: orderLink
                })
            })
        ]
    });
};
/* harmony default export */ var pages_Order = ((0,react_router/* withRouter */.EN)(Order));


/***/ }),

/***/ 99931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pages_OrderSuccess; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 1 modules
var react_router_dom = __webpack_require__(16592);
// EXTERNAL MODULE: ./components/ticketingNew/components/TourImageDescriptionMinized.tsx
var TourImageDescriptionMinized = __webpack_require__(70883);
// EXTERNAL MODULE: ./components/ticketingNew/components/StepsBlock.tsx
var StepsBlock = __webpack_require__(30510);
;// CONCATENATED MODULE: ./components/ticketingNew/components/TicketingButton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  border: ",
        ";\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.14);\n  border-radius: 12px;\n  padding: 16px 30px;\n  font-weight: 600;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: initial;\n\n  &:active {\n    ",
        "\n  }\n\n  &:focus {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ETickBtnType;
(function(ETickBtnType) {
    ETickBtnType[ETickBtnType["white"] = 0] = "white";
    ETickBtnType[ETickBtnType["red"] = 1] = "red";
})(ETickBtnType || (ETickBtnType = {}));
var MainWrap = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "TicketingButton__MainWrap",
    componentId: "sc-cf052c43-0"
})(_templateObject(), function(p) {
    return p.type == ETickBtnType.red ? "white" : "#EA475C";
}, function(p) {
    return p.type == ETickBtnType.red ? "#EA475C" : "white";
}, function(p) {
    return p.type == ETickBtnType.red ? "none" : "2px solid #EA475C";
}, function(p) {
    return p.type == ETickBtnType.red ? "opacity:0.8;" : "background-color:rgba(234,71,92,0.2);";
}, function(p) {
    return p.type == ETickBtnType.red ? "" : "border:2px solid #EA475C;";
});
var TicketingButton = function(props) {
    var text = props.text, _type = props.type, type = _type === void 0 ? ETickBtnType.red : _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainWrap, {
        type: type,
        children: text
    });
};
/* harmony default export */ var components_TicketingButton = (TicketingButton);

// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
;// CONCATENATED MODULE: ./components/ticketingNew/pages/OrderSuccess.tsx

function OrderSuccess_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  .bl-success-block-wrap {\n    background: #ffffff;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.14);\n    border-radius: 4px;\n    width: 570px;\n    margin: auto;\n    margin-top: 48px;\n    padding: 71px 37px 38px 37px;\n    position: relative;\n    text-align: center;\n\n    .bl-success-block-triangle {\n      width: 0;\n      height: 0;\n      border-top: 108px solid #ea475c;\n      border-right: 171px solid transparent;\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n\n    .bl-success-block-ok-sign {\n      width: 71px;\n      height: 71px;\n      background-color: #ea475c;\n      border-radius: 50%;\n      margin: auto;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: white;\n      font-size: 45px;\n      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n      margin-bottom: 20px;\n    }\n\n    .bl-success-block-title {\n      font-weight: 500;\n      font-size: 30px;\n      line-height: 45px;\n      margin-bottom: 20px;\n    }\n\n    .bl-success-block-text {\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 130.3%;\n      margin-bottom: 38px;\n    }\n\n    .bl-success-btns {\n      justify-content: space-between;\n      display: flex;\n      margin: auto;\n      margin-bottom: 40px;\n      width: 426px;\n\n      a {\n        text-decoration: initial;\n      }\n\n      button {\n        min-width: 202px;\n      }\n    }\n\n    .bl-success-block-safety {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 20px;\n      display: flex;\n      align-items: baseline;\n\n      .bl-success-block-safety-icon {\n        margin: 0 10px;\n        border: 1px solid black;\n        border-radius: 50%;\n        width: 28px;\n        height: 28px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n  @media screen and (max-width: 760px) {\n    .bl-success-block-wrap {\n      display: flex;\n      flex-direction: column;\n      max-width: calc(100% - 30px);\n      margin-left: 15px;\n      margin-right: 15px;\n      padding-top: 36px;\n      padding-bottom: 28px;\n\n      .bl-success-block-triangle {\n        border-top: 73px solid #ea475c;\n        border-right: 116px solid transparent;\n      }\n\n      .bl-success-block-ok-sign {\n        order: 1;\n      }\n\n      .bl-success-block-title {\n        order: 0;\n      }\n\n      .bl-success-block-text {\n        order: 3;\n      }\n\n      .bl-success-block-safety {\n        order: 4;\n      }\n\n      .bl-success-block-safety-icon {\n        min-width: 28px;\n      }\n\n      .bl-success-btns {\n        order: 4;\n        flex-wrap: wrap;\n        justify-content: center;\n\n        button {\n          width: 100%;\n        }\n\n        button:first-child {\n          margin-bottom: 15px;\n        }\n      }\n    }\n  }\n"
    ]);
    OrderSuccess_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var OrderSuccess_MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderSuccess__MainWrap",
    componentId: "sc-d2df32b8-0"
})(OrderSuccess_templateObject(), function(p) {
    return p.minimized ? "color:initial;" : "";
});
var OrderSuccess = function(props) {
    var location = props.location, _minimized = props.minimized, minimized = _minimized === void 0 ? false : _minimized, _onLinkClick = props.onLinkClick, onLinkClick = _onLinkClick === void 0 ? function() {} : _onLinkClick;
    var ticketsRes = (0,store/* useRecoilValue */.sJ)(store/* orderedTicketsState */.jF);
    var history = (0,react_router/* useHistory */.k6)();
    console.log("ticketsRes success page", ticketsRes);
    var firstTicket;
    var firstTicketCode;
    if (ticketsRes) {
        var ref;
        firstTicket = ticketsRes === null || ticketsRes === void 0 ? void 0 : (ref = ticketsRes.tickets) === null || ref === void 0 ? void 0 : ref.find(function(t) {
            return t.code;
        });
        firstTicketCode = firstTicket === null || firstTicket === void 0 ? void 0 : firstTicket.code;
    }
    var bookPage = location.pathname.replace(/book.+|book/g, "") + "book";
    if (!firstTicket) {
        react_toastify_esm/* toast.error */.Am.error("No ticket found, redirecting to home page");
        history.push(bookPage);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "redirect"
        });
    }
    var loginPage = location.pathname.replace(/book.+|book/g, "") + "login?ticket=".concat(firstTicketCode);
    if (firstTicket.type === "gameTour" && ticketsRes.gameId) loginPage.replace("/tour/", "/experience/".concat(ticketsRes.gameId, "/"));
    var ref1 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _payment_confirmed = ref1.payment_confirmed, payment_confirmed = _payment_confirmed === void 0 ? "Payment cofirmed" : _payment_confirmed, _full_transaction_details = ref1.full_transaction_details, full_transaction_details = _full_transaction_details === void 0 ? "The full transaction details will be sending to your Email" : _full_transaction_details, _protect_message = ref1.protect_message, protect_message = _protect_message === void 0 ? "We protect your payment information using encryption to provide bank-level security." : _protect_message, _book_more_tours = ref1.book_more_tours, book_more_tours = _book_more_tours === void 0 ? "Book More Tours" : _book_more_tours, _startTourNow = ref1.startTourNow, startTourNow = _startTourNow === void 0 ? "Start Tour Now" : _startTourNow;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderSuccess_MainWrap, {
        minimized: minimized,
        children: [
            !minimized && /*#__PURE__*/ (0,jsx_runtime.jsx)(TourImageDescriptionMinized/* default */.Z, {}),
            !minimized && /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsBlock/* default */.Z, {
                count: 3,
                active: 3,
                done: [
                    1,
                    2
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-success-block-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-triangle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-ok-sign",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "far fa-check"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-title",
                        children: payment_confirmed
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-text",
                        children: full_transaction_details
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-success-btns",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: bookPage,
                                onClick: onLinkClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TicketingButton, {
                                    text: book_more_tours,
                                    type: ETickBtnType.white
                                })
                            }),
                            firstTicketCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: loginPage,
                                onClick: onLinkClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TicketingButton, {
                                    text: startTourNow
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-success-block-safety",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-success-block-safety-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-lock"
                                })
                            }),
                            protect_message
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_OrderSuccess = ((0,react_router/* withRouter */.EN)(OrderSuccess));


/***/ }),

/***/ 70712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getTicketingTypeFromOrderedTicket; },
/* harmony export */   "Z": function() { return /* binding */ initialCurrency; }
/* harmony export */ });
var initialCurrency = [
    {
        id: 1,
        name: "Euro",
        code: "EUR",
        symbol: "€"
    },
    {
        id: 3,
        name: "US Dollar",
        code: "USD",
        symbol: "$"
    },
    {
        id: 9,
        name: "Israeli New Sheqel",
        code: "ILS",
        symbol: "₪"
    }, 
];
var getTicketingTypeFromOrderedTicket = function(ticketingOrderedTicket) {
    switch(ticketingOrderedTicket.ticketType){
        case "gameTour":
            return "ticketingGameTour";
        case "guidedTour":
            return "ticketingGuidedTour";
        // 'tourByYourself'
        default:
            return "ticketingToursByYourself";
    }
};


/***/ }),

/***/ 84345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ DurationType; }
/* harmony export */ });
var DurationType;
(function(DurationType) {
    DurationType["from_login"] = "from_login";
    DurationType["from_purchase"] = "from_purchase";
})(DurationType || (DurationType = {}));


/***/ }),

/***/ 12781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nJ": function() { return /* reexport */ activeItemState; },
  "hm": function() { return /* reexport */ audioConfigsState; },
  "b1": function() { return /* reexport */ bgImageState; },
  "DF": function() { return /* reexport */ bottomBarOpenState; },
  "b_": function() { return /* reexport */ captionsEnabledState; },
  "g$": function() { return /* reexport */ forceShowPathSwitchMobileModalState; },
  "F3": function() { return /* reexport */ gamePointsState; },
  "WW": function() { return /* reexport */ gameSoundOnState; },
  "WN": function() { return /* reexport */ gameSoundVolumeState; },
  "uP": function() { return /* reexport */ infoModalDataState; },
  "wN": function() { return /* reexport */ lockInfoPopupStatusState; },
  "bG": function() { return /* reexport */ lockTimerState; },
  "jF": function() { return /* reexport */ orderedTicketsState; },
  "Sy": function() { return /* reexport */ redirectTicketsState; },
  "y9": function() { return /* reexport */ sidebarMinimizedState; },
  "eo": function() { return /* reexport */ sidebarOpenState; },
  "Ys": function() { return /* reexport */ ticketingCurrentLanguage; },
  "$W": function() { return /* reexport */ ticketingDataState; },
  "Uq": function() { return /* reexport */ tourConfigsState; },
  "Jv": function() { return /* reexport */ translationDataState; },
  "FV": function() { return /* reexport */ recoil/* useRecoilState */.FV; },
  "sJ": function() { return /* reexport */ recoil/* useRecoilValue */.sJ; },
  "Zl": function() { return /* reexport */ recoil/* useSetRecoilState */.Zl; },
  "Jn": function() { return /* reexport */ youtubeOnState; }
});

// UNUSED EXPORTS: DefaultValue, RecoilLoadable, RecoilRoot, atom, atomFamily, constSelector, errorSelector, isRecoilValue, noWait, readOnlySelector, retentionZone, selector, selectorFamily, snapshot_UNSTABLE, useGetRecoilValueInfo_UNSTABLE, useGotoRecoilSnapshot, useRecoilBridgeAcrossReactRoots_UNSTABLE, useRecoilCallback, useRecoilRefresher_UNSTABLE, useRecoilSnapshot, useRecoilStateLoadable, useRecoilTransactionObserver_UNSTABLE, useRecoilTransaction_UNSTABLE, useRecoilValueLoadable, useResetRecoilState, useRetain, useSetUnvalidatedAtomValues_UNSTABLE, useTransactionObservation_UNSTABLE, waitForAll, waitForAllSettled, waitForAny, waitForNone

// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
;// CONCATENATED MODULE: ./store/atoms/basic.ts

var captionsEnabledState = (0,recoil/* atom */.cn)({
    key: "captionsEnabledState",
    default: true
});
var translationDataState = (0,recoil/* atom */.cn)({
    key: "translationDataState",
    default: null
});
var tourConfigsState = (0,recoil/* atom */.cn)({
    key: "tourConfigsState",
    default: {}
});
var forceShowPathSwitchMobileModalState = (0,recoil/* atom */.cn)({
    key: "forceShowPathSwitchMobileModalState",
    default: false
});
var audioConfigsState = (0,recoil/* atom */.cn)({
    key: "audioConfigsState",
    default: {
        muted: false,
        volume: 0.5,
        captionsEnabled: true
    }
});

;// CONCATENATED MODULE: ./store/atoms/game/sound.ts

var gameSoundOnState = (0,recoil/* atom */.cn)({
    key: "gameSoundOnState",
    default: true
});
var gameSoundVolumeState = (0,recoil/* atom */.cn)({
    key: "gameSoundVolumeState",
    default: 0.5
});

;// CONCATENATED MODULE: ./store/atoms/game/basic.ts

var lockTimerState = (0,recoil/* atom */.cn)({
    key: "lockTimerState",
    default: {
        running: false,
        value: 0
    }
});
var lockInfoPopupStatusState = (0,recoil/* atom */.cn)({
    key: "lockInfoPopupStatusState",
    default: null
});
var gamePointsState = (0,recoil/* atom */.cn)({
    key: "gamePointsState",
    default: 0
});

;// CONCATENATED MODULE: ./store/atoms/game/index.ts



// EXTERNAL MODULE: ./components/ticketingNew/components/InfoModal.tsx + 1 modules
var InfoModal = __webpack_require__(47887);
;// CONCATENATED MODULE: ./store/atoms/ticketing.ts


var ticketingCurrentLanguage = (0,recoil/* atom */.cn)({
    key: "ticketingCurrentLanguage",
    default: {}
});
var infoModalDataState = (0,recoil/* atom */.cn)({
    key: "infoModalDataState",
    default: {
        mode: InfoModal/* EInfoModal.error */.Y.error,
        isOpen: false
    }
});
var redirectTicketsState = (0,recoil/* atom */.cn)({
    key: "redirectTicketsState",
    default: null
});
var orderedTicketsState = (0,recoil/* atom */.cn)({
    key: "orderedTicketsState",
    default: null
});
var ticketingDataState = (0,recoil/* atom */.cn)({
    key: "ticketingDataState",
    default: null
});
var bgImageState = (0,recoil/* atom */.cn)({
    key: "bgImageState",
    default: ""
});

// EXTERNAL MODULE: ./components-new/eCommerce/BottomBar/types.ts
var types = __webpack_require__(40803);
;// CONCATENATED MODULE: ./store/atoms/eCommerce.ts


var activeItemState = (0,recoil/* atom */.cn)({
    key: "activeItemState",
    default: types/* EBottomBarActiveItem.cart */.C.cart
});
var bottomBarOpenState = (0,recoil/* atom */.cn)({
    key: "bottomBarOpenState",
    default: false
});
var sidebarMinimizedState = (0,recoil/* atom */.cn)({
    key: "sidebarMinimizedState",
    default: true
});
var sidebarOpenState = (0,recoil/* atom */.cn)({
    key: "sidebarOpenState",
    default: false
});
var youtubeOnState = (0,recoil/* atom */.cn)({
    key: "youtubeOnState",
    default: false
});

;// CONCATENATED MODULE: ./store/atoms/index.ts





;// CONCATENATED MODULE: ./store/index.ts

 // export * from './selectors';


/***/ })

}]);